import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import home_en from "../Local/en/home.json";
import home_cn from "../Local/zh_cn/home.json";
import home_hk from "../Local/zh_hk/home.json";
import studentMinistry_en from "../Local/en/studentMinistry.json";
import studentMinistry_cn from "../Local/zh_cn/studentMinistry.json";
import studentMinistry_hk from "../Local/zh_hk/studentMinistry.json";
import whereToFindUs_en from "../Local/en/whereToFindUs.json";
import whereToFindUs_cn from "../Local/zh_cn/whereToFindUs.json";
import whereToFindUs_hk from "../Local/zh_hk/whereToFindUs.json";
import youthMinistry_en from "../Local/en/youthMinistry.json";
import youthMinistry_cn from "../Local/zh_cn/youthMinistry.json";
import youthMinistry_hk from "../Local/zh_hk/youthMinistry.json";
import childrenMinistry_en from "../Local/en/childrenMinistry.json";
import childrenMinistry_cn from "../Local/zh_cn/childrenMinistry.json";
import childrenMinistry_hk from "../Local/zh_hk/childrenMinistry.json";
import homeGroup_en from "../Local/en/homeGroup.json";
import homeGroup_cn from "../Local/zh_cn/homeGroup.json";
import homeGroup_hk from "../Local/zh_hk/homeGroup.json";
import service_en from "../Local/en/service.json";
import service_cn from "../Local/zh_cn/service.json";
import service_hk from "../Local/zh_hk/service.json";
import trustees_en from "../Local/en/trustees.json";
import trustees_cn from "../Local/zh_cn/trustees.json";
import trustees_hk from "../Local/zh_hk/trustees.json";
import pastoralTeam_en from "../Local/en/pastoralteam.json";
import pastoralTeam_cn from "../Local/zh_cn/pastoralteam.json";
import pastoralTeam_hk from "../Local/zh_hk/pastoralteam.json";
import ourHistory_en from "../Local/en/ourhistory.json";
import ourHistory_cn from "../Local/zh_cn/ourhistory.json";
import ourHistory_hk from "../Local/zh_hk/ourhistory.json";
import appbar_en from "../Local/en/appbar.json";
import appbar_cn from "../Local/zh_cn/appbar.json";
import appbar_hk from "../Local/zh_hk/appbar.json";
import footer_en from "../Local/en/footer.json";
import footer_cn from "../Local/zh_cn/footer.json";
import footer_hk from "../Local/zh_hk/footer.json";
import ourBelief_en from "../Local/en/ourbelief.json";
import ourBelief_cn from "../Local/zh_cn/ourbelief.json";
import ourBelief_hk from "../Local/zh_hk/ourbelief.json";
import supportUs_en from "../Local/en/supportUs.json";
import supportUs_cn from "../Local/zh_cn/supportUs.json";
import supportUs_hk from "../Local/zh_hk/supportUs.json";
import whoWeAre_en from "../Local/en/whoWeAre.json";
import whoWeAre_cn from "../Local/zh_cn/whoWeAre.json";
import whoWeAre_hk from "../Local/zh_hk/whoWeAre.json";
import whatDoWeDo_en from "../Local/en/whatDoWeDo.json";
import whatDoWeDo_cn from "../Local/zh_cn/whatDoWeDo.json";
import whatDoWeDo_hk from "../Local/zh_hk/whatDoWeDo.json";
import Langauge from "../Const/Language";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
        [Langauge.English.Code]: {
            home: home_en,
            childrenMinistry: childrenMinistry_en,
            youthMinistry: youthMinistry_en,
            studentMinistry: studentMinistry_en,
            whereToFindUs: whereToFindUs_en,
            homeGroup: homeGroup_en,
            service: service_en,
            trustees: trustees_en,
            footer: footer_en,
            pastoralTeam: pastoralTeam_en,
            ourHistory: ourHistory_en,
            ourBelief: ourBelief_en,
            supportUs: supportUs_en,
            whoWeAre: whoWeAre_en,
            whatDoWeDo: whatDoWeDo_en,
            appbar: appbar_en
        },
        [Langauge.TraditionalChinese.Code]:{
            home: home_hk,
            childrenMinistry: childrenMinistry_hk,
            youthMinistry: youthMinistry_hk,
            studentMinistry: studentMinistry_hk,
            whereToFindUs: whereToFindUs_hk,
            homeGroup: homeGroup_hk,
            service: service_hk,
            trustees: trustees_hk,
            footer: footer_hk,
            pastoralTeam: pastoralTeam_hk,
            ourHistory: ourHistory_hk,
            ourBelief: ourBelief_hk,
            supportUs: supportUs_hk,
            whoWeAre: whoWeAre_hk,
            whatDoWeDo: whatDoWeDo_hk,
            appbar: appbar_hk
        },
        [Langauge.SimplifiedChinese.Code]:{
            home: home_cn,
            childrenMinistry: childrenMinistry_cn,
            youthMinistry: youthMinistry_cn,
            studentMinistry: studentMinistry_cn,
            whereToFindUs: whereToFindUs_cn,
            homeGroup: homeGroup_cn,
            service: service_cn,
            trustees: trustees_cn,
            footer: footer_cn,
            pastoralTeam: pastoralTeam_cn,
            ourHistory: ourHistory_cn,
            ourBelief: ourBelief_cn,
            supportUs: supportUs_cn,
            whoWeAre: whoWeAre_cn,
            whatDoWeDo: whatDoWeDo_cn,
            appbar: appbar_cn
        }
    },
    lng: Langauge.English.Code, // if you're using a language detector, do not define the lng option
    fallbackLng: Langauge.English.Code,

    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});

export default i18n;